var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFileIcon = function SvgFileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9821 7.71429H8.35714C7.84565 7.71429 7.35511 7.5111 6.99344 7.14942C6.63176 6.78774 6.42857 6.2972 6.42857 5.78571V0.160714C6.42857 0.11809 6.41164 0.0772119 6.3815 0.0470722C6.35136 0.0169324 6.31048 0 6.26786 0H2.57143C1.88944 0 1.23539 0.270918 0.753154 0.753154C0.270917 1.23539 0 1.88944 0 2.57143V15.4286C0 16.1106 0.270917 16.7646 0.753154 17.2468C1.23539 17.7291 1.88944 18 2.57143 18H11.5714C12.2534 18 12.9075 17.7291 13.3897 17.2468C13.8719 16.7646 14.1429 16.1106 14.1429 15.4286V7.875C14.1429 7.83238 14.1259 7.7915 14.0958 7.76136C14.0656 7.73122 14.0248 7.71429 13.9821 7.71429Z",
    fill: "#808080"
  })));
};
export default SvgFileIcon;